import React, { useState, useEffect, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//API
import supplierService from "../../../services/supplier_appCommonService";
import ItemService from "../../../services/ap_auto_appCommonService";
import { useDispatch } from "react-redux";

//Components
import Layout from "../../../Layout/Layout";
import ApproveRemarksModal from "../../../Components/Modal/supplier_app/ApproveRemarksModal";
import toast from "react-hot-toast";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import PdfViewerUpload2 from "./PdfViewerUpload2";
import DataTable from "react-data-table-component";
import { currencyFormat } from "../../../common/Validations";
import Constants from "../../../common/SupplierConstants";
import { getAPInvList } from "../../../redux/feature/ap_auto_app/apAutoSlice";
import AP_AUTOConstants from "../../../common/AP_AUTOConstants";
import { useNavigate } from "react-router-dom";

let ewayBillNumberData = [
  { id: "1", name: "Yes", code: "YES", description: "Yes" },
  { id: "2", name: "No", code: "NO", description: "No" },
];

let accountsStatusNumberData = [
  { id: "1", name: "Hold", code: "HOL", description: "Hold" },
  { id: "2", name: "Cancelled", code: "CAN", description: "Cancelled" },
  { id: "3", name: "Done", code: "DON", description: "Done" },
  { id: "4", name: "Pending", code: "PEN", description: "Pending" },
  {
    id: "5",
    name: "Reconciliation",
    code: "REC",
    description: "Reconciliation",
  },
];

const getEmptyRow = () => ({
  local_id: Date.now() + Math.random(),
  invoiceItemNr: "",
  transactionType: "APEXP",
  purchasingDocumentItemNr: "",
  grnItemNr: "",
  grnNr: "",
  materialCode: "",
  materialDescription: "",
  purchaseQuantity: 0,
  grnQuantity: 0,
  invoiceQuantity: 0,
  invBalancePurchaseQuantity: 0,
  originalBalancePurchaseQuantity: 999999,
  orderUnitOfMeasure: "",
  orderPriceUnit: 0,
  totalPrice: 0,
  invItemTaxValue: 0,
  taxCode: 0,
  netValue: 0,
  currencyCode: "",
  deliveryDate: "",
  taxAmount: 0,
  taxIdDesc: "",
  purchaseReqNr: "",
  purchaseReqitemNr: "",
  excessTolerance: "",
  shortageTolerance: "",
});

const ApExpInvCreation = () => {
  localStorage.setItem("menu", "Sales");
  localStorage.setItem("submenu", "Invoice");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  // eslint-disable-next-line
  const [modalShow, setModalShow] = useState(false);

  const [invoiceData, setInvoiceData] = useState({});
  const [getDropdownData, setDropdownData] = useState("");
  const [isManual, setIsManual] = useState(false);
  const [disabled, setDisabled] = useState(false);
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState({});

  useEffect(() => {
    setInvoiceData((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [getHeaderData, setHeaderData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const [itemTableData, setItemTableData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getCreateInvoiceData, setCreateInvoiceData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getSupplierBankData, setSupplierBankData] = useState(0);

  // eslint-disable-next-line
  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    transactionType: "APEXP",
    customerCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    customerInvoiceNo: "",
    customerInvoiceDate: "",
    customerInvoiceCurrency: "",
    customerBasicValue: "",
    customerFreightValue: "",
    customerTaxValue: "",
    customerOtherChargesValue: "",
    customerTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
    vendorInvoiceDate: "",
    vendorInvoiceNo: "",
    vendorBasicValue: "0.00",
    vendorTaxValue: "0",
    vendorOtherChargesValue: "0.00",
    vendorFreightValue: "",
    vendorTotalInvoiceValue: "0.00",
    invoiceValue: "0",
    subTotalValue: "0",
    getOtherChargesValue: "0.00",
    grossTotalValue: "0.00",
    getInvTaxTotalValue: "0",
    currency_display: "",
    vendorCode: "",
    vendorName: "",
    purchasingDocumentValue_display: "",
    taxAmount: "0",
    creditNoteNumber: "",
    accountsRemarks: "",
  });

  const toggleCardVisibility = () => setCardVisible(!isCardVisible);
  // eslint-disable-next-line
  const toggleCardVisibility9 = () => setCardVisible9(!isCardVisible9);

  const [budgetNr, setBudgetNr] = useState([]);

  useEffect(() => {
    if (!getDropdownData) return;

    setFormInputs((prev) => ({
      ...prev,
      budgetNr: getDropdownData?.code,
    }));
  }, [getDropdownData]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => {
      const updated = { ...prev, [name]: value };

      if (
        [
          "vendorBasicValue",
          "vendorTaxValue",
          "vendorOtherChargesValue",
          "vendorFreightValue",
        ].includes(name)
      ) {
        updated.vendorTotalInvoiceValue = (
          Number(
            name === "vendorBasicValue" ? value : updated.vendorBasicValue,
          ) +
          Number(name === "vendorTaxValue" ? value : updated.vendorTaxValue) +
          Number(
            name === "vendorOtherChargesValue"
              ? value
              : updated.vendorOtherChargesValue,
          ) +
          Number(
            name === "vendorFreightValue" ? value : updated.vendorFreightValue,
          )
        ).toFixed(2);
      }

      if (["subTotalValue", "getOtherChargesValue"].includes(name)) {
        updated.grossTotalValue = (
          Number(name === "subTotalValue" ? value : updated.subTotalValue) +
          Number(
            name === "getOtherChargesValue"
              ? value
              : updated.getOtherChargesValue,
          )
        ).toFixed(2);
      }

      return updated;
    });
  };
  const updateTableRow = (local_id, field, value) => {
    setItemTableData((prev) =>
      prev.map((item) =>
        item.local_id === local_id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const handleInputChangeTable = (
    id,
    value,
    grnQuantity,
    orderPriceUnit,
    invBalancePurchaseQuantity,
    originalBalancePurchaseQuantity,
  ) => {
    if (Number(originalBalancePurchaseQuantity) >= Number(value)) {
      let totalPriceVal = Number(orderPriceUnit) * Number(value);

      const updatedData = itemTableData.map((item) =>
        item.local_id === id
          ? {
              ...item,
              invoiceQuantity: Number(value),
              invBalancePurchaseQuantity: (
                Number(originalBalancePurchaseQuantity) - Number(value)
              ).toFixed(2),
              totalPrice: totalPriceVal,
              invItemTaxValue: Number(
                Number(item.taxCode / 100) * Number(value),
              ),
            }
          : item,
      );

      const filteredData = updatedData.filter(
        (item) =>
          item.hasOwnProperty("invoiceQuantity") && item.invoiceQuantity !== 0,
      );

      setItemTableData(updatedData);
      setCreateInvoiceData(filteredData);
      getTotalCount(updatedData);
    }
  };

  const getTotalCount = (data) => {
    const getTotal = data.reduce((acc, cur) => acc + (cur?.totalPrice || 0), 0);

    let invTotalTaxVal = 0;
    data.forEach((item) => {
      invTotalTaxVal +=
        (Number(item.taxCode) / 100) * Number(item.invoiceQuantity || 0);
    });

    setFormInputs((prev) => ({
      ...prev,
      invoiceValue: getTotal.toString(),
      subTotalValue: getTotal.toString(),
      vendorBasicValue: getTotal.toFixed(2),
      getInvTaxTotalValue: Number(invTotalTaxVal).toString(),
      vendorTaxValue: Number(invTotalTaxVal).toString(),
      grossTotalValue: (
        getTotal + Number(prev.getOtherChargesValue || 0)
      ).toFixed(2),
      vendorTotalInvoiceValue: (
        getTotal +
        Number(invTotalTaxVal) +
        Number(prev.getOtherChargesValue || 0) +
        Number(prev.vendorFreightValue || 0)
      ).toFixed(2),
    }));
  };

  const handleOcrData = (ocrResponseData) => {
    if (!ocrResponseData) return;
    toast.success("Invoice data extracted successfully!");
    setFormInputs((prev) => ({
      ...prev,
      ...ocrResponseData,
      vendorTotalInvoiceValue: (
        Number(ocrResponseData.vendorBasicValue || prev.vendorBasicValue || 0) +
        Number(ocrResponseData.vendorTaxValue || prev.vendorTaxValue || 0) +
        Number(
          ocrResponseData.vendorOtherChargesValue ||
            prev.vendorOtherChargesValue ||
            0,
        ) +
        Number(
          ocrResponseData.vendorFreightValue || prev.vendorFreightValue || 0,
        )
      ).toFixed(2),
    }));
    setInvoiceData((prev) => ({ ...prev, ...ocrResponseData }));
  };

  const handleSave = async () => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: {
        ...formInputs,
        items: itemTableData,
        creditNoteAttachment: invoiceData?.creditNoteAttachment ?? null,
      },
    };

    setDisabled(true);
    await ItemService.createAPInvoice(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Invoice saved successfully!", {
          duration: 4000,
          position: "top-right",
        });
        setModalInfo({ successMsg: item?.message });
        dispatch(getAPInvList());
        navigate(AP_AUTOConstants.AP_EXP_INV_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const getMasterData = async () => {
    try {
      let obj = {
        queryName: "Get_BudgetCode_List",
      };

      const item = await ItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setBudgetNr(item?.data || []);
      } else {
        setBudgetNr([]);
        console.log(">> Error: Loading BudgetNr");
      }
    } catch (error) {
      console.log("API Error:", error);
      setBudgetNr([]);
    }
  };

  useEffect(() => {
    getMasterData();
  }, []);

  const navigateToWorkflow = () => window.history.back();

  // eslint-disable-next-line
  const [files, setFiles] = useState();
  // eslint-disable-next-line
  const [status, setStatus] = useState(true);

  const loadUploadedFiles = async (attachmentId) => {
    if (attachmentId) {
      let obj = { attachmentId };
      setStatus(true);
      await supplierService.getUploadedFiles(obj).then((item) => {
        setFiles(item?.data?.[item.data.length - 1] || null);
      });
      setStatus(false);
    }
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => setShowFileViewModal(false);
  const onSuccessUploadCreditNoteCard = (data) => {
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";
    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }
    setInvoiceData((prev) => ({
      ...prev,
      creditNoteAttachment: attachmentId,
      creditNoteFileName: fileName,
    }));
    loadUploadedFiles(attachmentId);
    toast.success("Invoice uploaded successfully!", {
      duration: 4000,
      position: "top-right",
    });
  };
  const invoiceDataColumns = useMemo(
    () => [
      {
        name: "Invoice Item Nr",
        selector: (row) => row.invoiceItemNr,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.invoiceItemNr || ""}
              onChange={(e) =>
                updateTableRow(row.local_id, "invoiceItemNr", e.target.value)
              }
            />
          ) : (
            <span>{row.invoiceItemNr}</span>
          ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.purchasingDocumentItemNr || ""}
              onChange={(e) =>
                updateTableRow(
                  row.local_id,
                  "purchasingDocumentItemNr",
                  e.target.value,
                )
              }
            />
          ) : (
            <span>{row.purchasingDocumentItemNr}</span>
          ),
        sortable: true,
        width: "120px",
      },
      {
        name: "GRN Item Nr",
        selector: (row) => row.grnItemNr,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.grnItemNr || ""}
              onChange={(e) =>
                updateTableRow(row.local_id, "grnItemNr", e.target.value)
              }
            />
          ) : (
            <span>{row.grnItemNr}</span>
          ),
        sortable: true,
        width: "130px",
      },
      {
        name: "GRN Nr",
        selector: (row) => row.grnNr,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.grnNr || ""}
              onChange={(e) =>
                updateTableRow(row.local_id, "grnNr", e.target.value)
              }
            />
          ) : (
            <span>{row.grnNr}</span>
          ),
        sortable: true,
        width: "130px",
      },
      {
        name: "Status",
        cell: () => (
          <span className="bg-table-status bg-table-info-status">{"New"}</span>
        ),
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) =>
          isManual ? (
            <div>
              <InputField
                className="inputBox mt-1"
                placeholder="Material Code"
                value={row.materialCode || ""}
                onChange={(e) =>
                  updateTableRow(row.local_id, "materialCode", e.target.value)
                }
              />
              <InputField
                className="inputBox mt-1"
                placeholder="Description"
                value={row.materialDescription || ""}
                onChange={(e) =>
                  updateTableRow(
                    row.local_id,
                    "materialDescription",
                    e.target.value,
                  )
                }
              />
            </div>
          ) : (
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode}</p>
              <p className="m-0 p-0">{row.materialDescription}</p>
            </div>
          ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Purchase Qty",
        selector: (row) => row.purchaseQuantity,
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="purchaseQuantity"
            value={row.purchaseQuantity}
            disabled={true}
          />
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "GRN Qty",
        selector: (row) => row.grnQuantity,
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="grnQuantity"
            value={row.grnQuantity}
            disabled={true}
          />
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Invoice Qty",
        cell: (row) => (
          <InputField
            type="number"
            className="inputBox mt-1"
            id="invoiceQuantity"
            name="invoiceQuantity"
            value={row.invoiceQuantity}
            onChange={(e) =>
              handleInputChangeTable(
                row.local_id,
                e.target.value,
                row.grnQuantity,
                row.orderPriceUnit,
                row.invBalancePurchaseQuantity,
                row.originalBalancePurchaseQuantity,
              )
            }
            disabled={!isManual || row.originalBalancePurchaseQuantity === 0}
          />
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Invoice Balance Qty",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="invBalancePurchaseQuantity"
            value={Number(row?.invBalancePurchaseQuantity) || 0}
            disabled={true}
          />
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Oder Unit",
        selector: (row) => row.orderUnitOfMeasure,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.orderUnitOfMeasure || ""}
              onChange={(e) =>
                updateTableRow(
                  row.local_id,
                  "orderUnitOfMeasure",
                  e.target.value,
                )
              }
            />
          ) : (
            <span>{row.orderUnitOfMeasure}</span>
          ),
        sortable: true,
        width: "120px",
      },
      {
        name: "Unit Price",
        cell: (row) =>
          isManual ? (
            <InputField
              type="number"
              className="inputBox mt-1"
              value={row.orderPriceUnit || 0}
              onChange={(e) => {
                const newPrice = Number(e.target.value);
                const newTotal = newPrice * Number(row.invoiceQuantity || 0);
                setItemTableData((prev) => {
                  const updated = prev.map((item) =>
                    item.local_id === row.local_id
                      ? {
                          ...item,
                          orderPriceUnit: newPrice,
                          totalPrice: newTotal,
                        }
                      : item,
                  );
                  getTotalCount(updated);
                  return updated;
                });
              }}
            />
          ) : (
            <span className="numberFormate">
              {currencyFormat(Number(row.orderPriceUnit).toFixed(2))}
            </span>
          ),
        sortable: true,
        width: "120px",
      },
      {
        name: "Item Value",
        selector: (row) => row.totalPrice,
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="totalPrice"
            value={row.totalPrice || 0}
            disabled={true}
          />
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Inv Item TAX",
        selector: (row) => row.invItemTaxValue,
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="invItemTaxValue"
            value={
              Number(Number(row.taxCode / 100) * Number(row.invoiceQuantity)) ||
              0
            }
            disabled={true}
          />
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Tax Code",
        selector: (row) => row.taxCode,
        cell: (row) =>
          isManual ? (
            <InputField
              type="number"
              className="inputBox mt-1"
              value={row.taxCode || 0}
              onChange={(e) => {
                updateTableRow(row.local_id, "taxCode", Number(e.target.value));
                getTotalCount(
                  itemTableData.map((item) =>
                    item.local_id === row.local_id
                      ? { ...item, taxCode: Number(e.target.value) }
                      : item,
                  ),
                );
              }}
            />
          ) : (
            <span>{row.taxCode}</span>
          ),
        sortable: true,
        width: "130px",
      },
      {
        name: "Total Value",
        selector: (row) => row.netValue,
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="netValue"
            value={row.netValue || 0}
            disabled={true}
          />
        ),
        sortable: true,
        width: "180px",
      },
      {
        name: "Currency",
        selector: (row) => row.currencyCode,
        cell: (row) =>
          isManual ? (
            <InputField
              className="inputBox mt-1"
              value={row.currencyCode || ""}
              onChange={(e) =>
                updateTableRow(row.local_id, "currencyCode", e.target.value)
              }
            />
          ) : (
            <span>{row.currencyCode}</span>
          ),
        sortable: true,
        width: "120px",
      },
      {
        name: "Delivery Date",
        selector: (row) => row.deliveryDate,
        cell: (row) =>
          isManual ? (
            <InputField
              type="date"
              className="inputBox mt-1"
              value={row.deliveryDate || ""}
              onChange={(e) =>
                updateTableRow(row.local_id, "deliveryDate", e.target.value)
              }
            />
          ) : (
            <span>{row.deliveryDate}</span>
          ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Tax Amount",
        selector: (row) => row.taxAmount,
        sortable: true,
        width: "140px",
      },
      {
        name: "Tax Desc",
        selector: (row) => row.taxIdDesc,
        sortable: true,
        width: "200px",
      },
      {
        name: "PReq Nr",
        selector: (row) => row.purchaseReqNr,
        sortable: true,
        width: "200px",
      },
      {
        name: "PReq Item Nr ",
        selector: (row) => row.purchaseReqitemNr,
        sortable: true,
        width: "200px",
      },
      {
        name: "ExcessTolerance",
        selector: (row) => row.excessTolerance,
        sortable: true,
        width: "200px",
      },
      {
        name: "ShortageTolerance",
        selector: (row) => row.shortageTolerance,
        sortable: true,
        width: "200px",
      },
      // ✅ Delete row — only in manual mode
      ...(isManual
        ? [
            {
              name: "Action",
              cell: (row) => (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    const updated = itemTableData.filter(
                      (item) => item.local_id !== row.local_id,
                    );
                    setItemTableData(updated);
                    getTotalCount(updated);
                  }}
                >
                  <i className="bi bi-trash"></i>
                </button>
              ),
              width: "80px",
            },
          ]
        : []),
    ],
    // eslint-disable-next-line
    [isManual, itemTableData],
  );

  const formattedBudget = useMemo(() => {
    return (budgetNr || []).map((item) => ({
      ...item,
      name: item.budget || `${item.budgetNr} - ${item.department || ""}`,
      code: item.budgetNr,
      description: item.budget || `${item.budgetNr} - ${item.department || ""}`,
    }));
  }, [budgetNr]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              AP Expense Invoice <span></span>
            </h2>
            <p className="subText">Invoice</p>
            <hr />

         
            <Row className="mb-4">
              <Col xs={12} md={8} lg={8} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col
                xs={12}
                md={4}
                lg={4}
                className="text-right d-flex justify-content-end align-items-center"
              >
                <button
                  className="btn btn-primary px-4"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  {disabled ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-save me-2"></i> Save
                    </>
                  )}
                </button>
              </Col>
            </Row>

            <>
              {/* PDF Viewer */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PV</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">PDF Viewer</span>
                        <span className="subHeaderTitle">PDF Viewer</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}
                  >
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={12}
                              lg={6}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <PdfViewerUpload2 onOcrExtract={handleOcrData} /> */}
                              <PdfViewerUpload2
                                onOcrExtract={handleOcrData}
                                onSuccessUpload={onSuccessUploadCreditNoteCard} // ← THIS was missing
                                getUploadedFiles={loadUploadedFiles}
                                value={invoiceData?.creditNoteAttachment}
                                name="creditNoteAttachment"
                                id="creditNoteAttachment"
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              lg={6}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <div
                                  className="accordion mb-4"
                                  id="accordionExample"
                                >
                                  <div className="accordion-item">
                                    <div
                                      className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""}`}
                                    >
                                      <div className="accordion-body">
                                        <Row>
                                          <Col xs={12} md={12} lg={12}>
                                            <div className="accordion-body">
                                              <Row className="pt-2 pb-4">
                                                {/* ✅ Manual Entry Toggle */}
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={12}
                                                  className="commTopButtonRightLeftPadding mb-2 d-flex align-items-center gap-3"
                                                >
                                                  <div className="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id="manualToggle"
                                                      checked={isManual}
                                                      onChange={(e) =>
                                                        setIsManual(
                                                          e.target.checked,
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                    <label
                                                      className="form-check-label fw-medium mb-0"
                                                      htmlFor="manualToggle"
                                                    >
                                                      Manual Entry
                                                    </label>
                                                  </div>
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={3}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    label={
                                                      <>
                                                        <i className="bi bi-check-circle labelIcon"></i>
                                                        Accounts Status
                                                      </>
                                                    }
                                                    extraLabel=""
                                                    name="accountsStatus"
                                                    code="accountsStatusCode"
                                                    description="accountsStatusDesc"
                                                    data={
                                                      accountsStatusNumberData
                                                    }
                                                    id="accountsStatus"
                                                    iconClassName="dropdownIcon"
                                                    setValue={
                                                      invoiceData?.accountsStatus
                                                    }
                                                    getvalue={setDropdownData}
                                                    required={false}
                                                    disabled={!isManual}
                                                  />
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={3}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox"
                                                    // label="Credit Note Number"
                                                    label={
                                                      <>
                                                        <i className="bi bi-receipt labelIcon"></i>
                                                        Credit Note Number
                                                      </>
                                                    }
                                                    name="creditNoteNumber"
                                                    id="creditNoteNumber"
                                                    value={
                                                      formInputs?.creditNoteNumber ||
                                                      ""
                                                    }
                                                    onChange={onInputChange}
                                                    disabled={!isManual}
                                                  />
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={3}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <TextAreaField
                                                    className="inputBox"
                                                    // label="Accounts Remarks"
                                                    label={
                                                      <>
                                                        <i className="bi bi-chat-left-text labelIcon"></i>
                                                        Accounts Remarks
                                                      </>
                                                    }
                                                    name="accountsRemarks"
                                                    id="accountsRemarks"
                                                    value={
                                                      formInputs?.accountsRemarks ||
                                                      ""
                                                    }
                                                    onChange={onInputChange}
                                                    disabled={!isManual}
                                                  />
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={6}
                                                  lg={3}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    // label="e-Way Bill Number"
                                                    label={
                                                      <>
                                                        <i className="bi bi-truck labelIcon"></i>
                                                        e-Way Bill Number
                                                      </>
                                                    }
                                                    extraLabel=""
                                                    name="ewayBill"
                                                    code="ewayBillCode"
                                                    description="ewayBillDesc"
                                                    data={ewayBillNumberData}
                                                    id="ewayBill"
                                                    iconClassName="dropdownIcon"
                                                    setValue={
                                                      invoiceData?.ewayBill
                                                    }
                                                    getvalue={setDropdownData}
                                                    required={true}
                                                    disabled={!isManual}
                                                  />
                                                </Col>

                                                <p className="text-primary fw-bold pb-0 commTopButtonRightLeftPadding">
                                                  Invoice Header
                                                </p>
                                                <Row className="pt-2 pb-4">
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <ComboboxField
                                                      label={
                                                        <>
                                                          <i className="bi bi-wallet2 labelIcon"></i>
                                                          Select Budget
                                                        </>
                                                      }
                                                      placeholder="Select Budget"
                                                      data={formattedBudget}
                                                      id="budgetCode"
                                                      name="budgetCode"
                                                      code="code"
                                                      description="description"
                                                      setValue={
                                                        formInputs?.budgetCode
                                                      }
                                                      getvalue={setDropdownData}
                                                      index={formInputs.id}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Invoice Date"
                                                      label={
                                                        <>
                                                          <i className="bi bi-calendar-date labelIcon"></i>
                                                          Invoice Date
                                                        </>
                                                      }
                                                      name="vendorInvoiceDate"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.vendorInvoiceDate ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Invoice Value"
                                                      label={
                                                        <>
                                                          <i className="bi bi-currency-rupee labelIcon"></i>
                                                          Invoice Value
                                                        </>
                                                      }
                                                      name="invoiceValue"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.invoiceValue ||
                                                        "0"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Weigh Slip Qty"
                                                      label={
                                                        <>
                                                          <i className="bi bi-box-seam labelIcon"></i>
                                                          Weigh Slip Qty
                                                        </>
                                                      }
                                                      name="weighSlipQty"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.weighSlipQty ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  {/* <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Currency"
                                                      label={
                                                        <>
                                                          <i className="bi bi-cash-stack labelIcon"></i>
                                                          Currency
                                                        </>
                                                      }
                                                      name="currency_display"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.currency_display ||
                                                        `${getHeaderData?.currencyCode || ""} - ${getHeaderData?.currency || ""}`
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col> */}
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      label={
                                                        <>
                                                          <i className="bi bi-cash-stack labelIcon"></i>
                                                          Currency
                                                        </>
                                                      }
                                                      name="currency_display"
                                                      value={
                                                        formInputs?.currency_display ||
                                                        "INR - Indian Rupee"
                                                      }
                                                      disabled
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="PO Number"
                                                      label={
                                                        <>
                                                          <i className="bi bi-file-earmark-text labelIcon"></i>
                                                          PO Number
                                                        </>
                                                      }
                                                      name="purchasingDocumentNr"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.purchasingDocumentNr ||
                                                        getHeaderData?.purchasingDocumentNr ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="PO Value"

                                                      label={
                                                        <>
                                                          <i className="bi bi-wallet2 labelIcon"></i>
                                                          PO Value
                                                        </>
                                                      }
                                                      name="purchasingDocumentValue"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.purchasingDocumentValue ||
                                                        getHeaderData?.purchasingDocumentValue ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Vendor"
                                                      label={
                                                        <>
                                                          <i className="bi bi-person labelIcon"></i>
                                                          Vendor
                                                        </>
                                                      }
                                                      name="vendorCode"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.vendorCode ||
                                                        getHeaderData?.vendorCode ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Vendor Name"
                                                      label={
                                                        <>
                                                          <i className="bi bi-person-badge labelIcon"></i>
                                                          Vendor Name
                                                        </>
                                                      }
                                                      name="vendorName"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.vendorName ||
                                                        getHeaderData?.vendorName ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Tax Amount"
                                                      label={
                                                        <>
                                                          <i className="bi bi-percent labelIcon"></i>
                                                          Tax Amount
                                                        </>
                                                      }
                                                      name="taxAmount"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.taxAmount ||
                                                        formInputs?.getInvTaxTotalValue ||
                                                        "0"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <TextAreaField
                                                      className="inputBox"
                                                      // label="Notes"
                                                      label={
                                                        <>
                                                          <i className="bi bi-journal-text labelIcon"></i>
                                                          Notes
                                                        </>
                                                      }
                                                      name="notes"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.notes || ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                </Row>

                                                <p className="text-primary fw-bold pb-0 commTopButtonRightLeftPadding">
                                                  Invoice Service Item Details
                                                </p>

                                                {/* ✅ Add Row button — only in manual mode */}
                                                {isManual && (
                                                  <Row className="mb-2">
                                                    <Col
                                                      xs={12}
                                                      className="commTopButtonRightLeftPadding d-flex justify-content-end"
                                                    >
                                                      <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() =>
                                                          setItemTableData(
                                                            (prev) => [
                                                              ...prev,
                                                              getEmptyRow(),
                                                            ],
                                                          )
                                                        }
                                                      >
                                                        <i className="bi bi-plus-circle me-1"></i>{" "}
                                                        Add Row
                                                      </button>
                                                    </Col>
                                                  </Row>
                                                )}

                                                <Row>
                                                  <Col xs={12} md={12} lg={12}>
                                                    <DataTable
                                                      columns={
                                                        invoiceDataColumns
                                                      }
                                                      data={itemTableData}
                                                      paginationRowsPerPageOptions={
                                                        Constants.ROW_PER_PAGE
                                                      }
                                                      pagination
                                                      selectableRows
                                                    />
                                                  </Col>
                                                </Row>

                                                <p className="text-primary fw-bold pb-0 commTopButtonRightLeftPadding">
                                                  Pricing Summary
                                                </p>
                                                <Row className="ms-3">
                                                  <Col
                                                    xs={8}
                                                    md={4}
                                                    lg={4}
                                                    className="d-flex my-2 jsutify-content-center align-items-center"
                                                  >
                                                    <p className="fw-medium">
                                                      SubTotal Pricing Schedule
                                                      / Line Items
                                                    </p>
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    md={6}
                                                    lg={6}
                                                    className="d-flex my-2 jsutify-content-center align-items-center"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      name="subTotalValue"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.subTotalValue ||
                                                        "0"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={8}
                                                    md={4}
                                                    lg={4}
                                                    className="d-flex my-2 jsutify-content-center align-items-center"
                                                  >
                                                    <p className="fw-medium">
                                                      SubTotal Other Charges
                                                    </p>
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    md={7}
                                                    lg={7}
                                                    className="d-flex my-2 jsutify-content-center align-items-center"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      name="getOtherChargesValue"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.getOtherChargesValue ||
                                                        "0.00"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={8}
                                                    md={4}
                                                    lg={4}
                                                    className="d-flex my-2 jsutify-content-center align-items-center"
                                                  >
                                                    <p className="fw-medium">
                                                      Gross Total
                                                    </p>
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    md={7}
                                                    lg={7}
                                                    className="d-flex jsutify-content-center align-items-center"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      name="grossTotalValue"
                                                      placeholder=""
                                                      value={
                                                        formInputs?.grossTotalValue ||
                                                        "0.00"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                </Row>

                                                <p className="text-primary fw-bold pb-0 commTopButtonRightLeftPadding">
                                                  Invoice details
                                                </p>
                                                <Row className="pt-2 pb-4">
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Invoice Number *"
                                                      label={
                                                        <>
                                                          <i className="bi bi-receipt labelIcon"></i>
                                                          Invoice Number *
                                                        </>
                                                      }
                                                      name="vendorInvoiceNo"
                                                      id="vendorInvoiceNo"
                                                      value={
                                                        formInputs?.vendorInvoiceNo ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Invoice Date*"
                                                      label={
                                                        <>
                                                          <i className="bi bi-calendar-date labelIcon"></i>
                                                          Invoice Date *
                                                        </>
                                                      }
                                                      name="vendorInvoiceDate"
                                                      id="vendorInvoiceDate"
                                                      type="date"
                                                      value={
                                                        formInputs?.vendorInvoiceDate ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Basic Value *"

                                                      label={
                                                        <>
                                                          <i className="bi bi-currency-rupee labelIcon"></i>
                                                          Basic Value *
                                                        </>
                                                      }
                                                      name="vendorBasicValue"
                                                      placeholder="0.00"
                                                      id="vendorBasicValue"
                                                      value={
                                                        formInputs?.vendorBasicValue ||
                                                        "0.00"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Tax Amount"
                                                      label={
                                                        <>
                                                          <i className="bi bi-percent labelIcon"></i>
                                                          Tax Amount
                                                        </>
                                                      }
                                                      name="vendorTaxValue"
                                                      placeholder="0.00"
                                                      id="vendorTaxValue"
                                                      value={
                                                        formInputs?.vendorTaxValue ||
                                                        formInputs?.getInvTaxTotalValue ||
                                                        "0"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Other Charges"
                                                      label={
                                                        <>
                                                          <i className="bi bi-plus-square labelIcon"></i>
                                                          Other Charges
                                                        </>
                                                      }
                                                      name="vendorOtherChargesValue"
                                                      placeholder="0.00"
                                                      id="vendorOtherChargesValue"
                                                      value={
                                                        formInputs?.vendorOtherChargesValue ||
                                                        "0.00"
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Freight Value"
                                                      label={
                                                        <>
                                                          <i className="bi bi-truck labelIcon"></i>
                                                          Freight Value
                                                        </>
                                                      }
                                                      name="vendorFreightValue"
                                                      placeholder="0.00"
                                                      id="vendorFreightValue"
                                                      value={
                                                        formInputs?.vendorFreightValue ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Total Invoice Value"
                                                      label={
                                                        <>
                                                          <i className="bi bi-cash labelIcon"></i>
                                                          Total Invoice Value
                                                        </>
                                                      }
                                                      name="vendorTotalInvoiceValue"
                                                      placeholder="0.00"
                                                      id="vendorTotalInvoiceValue"
                                                      value={
                                                        formInputs?.vendorTotalInvoiceValue ||
                                                        "0.00"
                                                      }
                                                      disabled={true}
                                                    />
                                                  </Col>
                                                </Row>

                                                <p className="text-primary fw-bold pb-0 commTopButtonRightLeftPadding">
                                                  Invoice Bank Details
                                                </p>
                                                <Row className="pt-2 pb-4">
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <ComboboxField
                                                      // label="Select Bank A/C Number"
                                                      label={
                                                        <>
                                                          <i className="bi bi-credit-card labelIcon"></i>
                                                          Select Bank A/C Number
                                                        </>
                                                      }
                                                      placeholder=""
                                                      data={getSupplierBankData}
                                                      id="selectedBankDetails"
                                                      iconClassName="dropdownIcon"
                                                      name="selectedBankDetails"
                                                      setValue={
                                                        formInputs
                                                          ?.selectedBankDetails
                                                          ?.name || []
                                                      }
                                                      getvalue={setDropdownData}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Bank Account Holder Name"
                                                      label={
                                                        <>
                                                          <i className="bi bi-person labelIcon"></i>
                                                          Bank Account Holder
                                                          Name
                                                        </>
                                                      }
                                                      name="AccountHolderName"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.AccountHolderName ||
                                                        ""
                                                      }
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Swift Code/ IFSC Code"
                                                      label={
                                                        <>
                                                          <i className="bi bi-code-slash labelIcon"></i>
                                                          Swift Code / IFSC Code
                                                        </>
                                                      }
                                                      name="swiftIfscCode"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.swiftIfscCode ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Bank Name"
                                                      label={
                                                        <>
                                                          <i className="bi bi-building labelIcon"></i>
                                                          Bank Name
                                                        </>
                                                      }
                                                      name="bankName2"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.bankName2 ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Branch Address"
                                                      label={
                                                        <>
                                                          <i className="bi bi-geo-alt labelIcon"></i>
                                                          Branch Address
                                                        </>
                                                      }
                                                      name="bankAddress"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.bankAddress ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Bank Country"
                                                      label={
                                                        <>
                                                          <i className="bi bi-globe labelIcon"></i>
                                                          Bank Country
                                                        </>
                                                      }
                                                      name="bankCountry"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.bankCountry ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="Bank ID"
                                                      label={
                                                        <>
                                                          <i className="bi bi-upc labelIcon"></i>
                                                          Bank ID
                                                        </>
                                                      }
                                                      name="bankKey"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.bankKey ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding d-flex-column"
                                                  >
                                                    <InputField
                                                      className="inputBox"
                                                      // label="IBAN"
                                                      label={
                                                        <>
                                                          <i className="bi bi-upc-scan labelIcon"></i>
                                                          IBAN
                                                        </>
                                                      }
                                                      name="iban"
                                                      placeholder=""
                                                      value={
                                                        getDropdownData?.iban ||
                                                        ""
                                                      }
                                                      onChange={onInputChange}
                                                      disabled={!isManual}
                                                    />
                                                  </Col>
                                                </Row>

                                                {!invoiceData?.invoiceCreated && (
                                                  <Col
                                                    xs={12}
                                                    md={6}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <Row>
                                                      <Col
                                                        xs={2}
                                                        md={2}
                                                        lg={2}
                                                        className="d-flex align-items-center"
                                                      >
                                                        {invoiceData?.creditNoteAttachment && (
                                                          <img
                                                            src="assets/img/newIcons/attached-file.png"
                                                            className="attachmentIcon me-2"
                                                            alt="view"
                                                            onClick={() =>
                                                              handleViewFile(
                                                                invoiceData?.creditNoteAttachment,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            title="View signature"
                                                          />
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                )}

                                                {invoiceData?.invoiceCreated && (
                                                  <Col
                                                    xs={12}
                                                    md={6}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                  >
                                                    <Row>
                                                      <Col
                                                        xs={2}
                                                        md={2}
                                                        lg={2}
                                                        className="d-flex align-items-center"
                                                      >
                                                        {invoiceData?.creditNoteAttachment && (
                                                          <img
                                                            src="assets/img/newIcons/attached-file.png"
                                                            className="attachmentIcon me-2"
                                                            alt="view"
                                                            onClick={() =>
                                                              handleViewFile(
                                                                invoiceData?.creditNoteAttachment,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            title="View signature"
                                                          />
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                )}
                                              </Row>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Col>
      </Row>

      <ApproveRemarksModal show={modalShow} />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default ApExpInvCreation;
